module.exports = __webpack_public_path__ + "static/flatart.guncel-466475b1d9dccd1c89b402c882031479.mp4";